import { jsx } from "react/jsx-runtime";
import { Container } from "@crehana/ui";
import { css } from "styled-components";
const NavbarContainer = ({ className, navType = 'default', children })=>/*#__PURE__*/ jsx(Container, {
        className: className,
        type: navType,
        css: css`
      ${(props)=>props.theme.breakpoints.up('md')} {
        width: calc(100% - 80px);
      }
      ${(props)=>props.theme.breakpoints.up('sm')} {
        ${'dashboard' === navType && `
          max-width: 100% !important;
          width: calc(100% - 128px);
        `}
      }
    `,
        children: children
    });
const ui_NavbarContainer = NavbarContainer;
export default ui_NavbarContainer;
